import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { DocumentCornSchema, InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
export const DeleteDocumentApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
        documentId: DocumentCornSchema,
    }),
    query: z.object({}),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
};
export const DeleteDocumentRequestSchema = DeleteDocumentApiSchema.params.merge(DeleteDocumentApiSchema.headers);
